import { GiVenezuela } from "react-icons/gi";

export const consultantOptions = [
    { value: "PCPL", label: "PCPL" },

];

export const disciplineOptions = [
    { value: "STRU", label: "STRU" },
    { value: "ARCH", label: "ARCH" },
    { value: "MEP", label: "MEP" },
    { value: "ELEC", label: "ELEC" },
    { value: "ELV", label: "ELV" },
    { value: "EL", label: "EL" },
];

export const stageOptions = [
    { value: "EX", label: "EX" },
    { value: "TS01", label: "TS01" },
    { value: "TS", label: "TS" },
];

export const statusOptions = [
    { value: "Planned", label: "Planned" },
    { value: "Received", label: "Received" },
    { value: "Pending", label: "Pending" },
    { value: "In Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
];

export const blockOptions =[
    { value: "Boundary wall between WH-1 and Commercial area", label: "Road Infrastructure" },
    { value: "D-Type boudary Wall Entry", label: "D-Type boudary Wall Entry" },
    { value: "Nallah Cum Boundary Wall (South Side", label: "Nallah Cum Boundary Wall (South Side" },
    { value: "Land Development", label: "Land Development" },
    { value: "Roads Infrastructure", label: "Roads Infrastructure" },
    { value: "Utilities and Ancilliary Buildings", label: "Utilities and Ancilliary Buildings" },
    { value: "Boom Barrier & Security Cabins", label: "Boom Barrier & Security Cabins" },
    { value: "Weigh Bridge", label: "Weigh Bridge" },
    { value: "Landscaping and Horticulture", label: "Landscaping and Horticulture" },
    { value: "Boundary Wall", label: "Boundary Wal" },
    { value: "Warehouse-01", label: "Warehouse -01" },
    { value: "Boded Warehouse", label: "Bonded Warehouse" },
    { value: "Rail Yard Terminal", label: "Rail Yard Terminal" },
    { value: "Domestic Container Yard ( DCT/ DFT)", label: "Domestic Container Yard ( DCT/ DFT)" },
    { value: "ICD", label: "ICD" },
    { value: "Admin & Custom Building", label: "Admin & Custom Building" },
    { value: "Parking Area and Driver Rest Room", label: "Parking Area and Driver Rest Room" },
    { value: "Petrol Pump and Fuel Station", label: "Petrol Pump and Fuel Station" },
    { value: "Hotel", label: "Hotel" },
]

export const blockOptions_2 = [
    { value: "Boundary wall between WH-1 and Commercial area", label: "Road Infrastructure" },
    { value: "D-Type boudary Wall Entry", label: "D-Type boudary Wall Entry" },
    { value: "Nallah Cum Boundary Wall (South Side", label: "Nallah Cum Boundary Wall (South Side" },
    { value: "Land Development", label: "Land Development" },
    { value: "Roads Infrastructure", label: "Roads Infrastructure" },
    { value: "Utilities and Ancilliary Buildings", label: "Utilities and Ancilliary Buildings" },
    { value: "Boom Barrier & Security Cabins", label: "Boom Barrier & Security Cabins" },
    { value: "Weigh Bridge", label: "Weigh Bridge" },
    { value: "Landscaping and Horticulture", label: "Landscaping and Horticulture" },
    { value: "Boundary Wall", label: "Boundary Wal" },
]

export const blockOptions_1 = [
    { value: "Warehouse-01", label: "Warehouse-01" },
    { value: "Boded Warehouse", label: "Bonded Warehouse" },
    { value: "Rail Yard Terminal", label: "Rail Yard Terminal" },
    { value: "Domestic Container Yard ( DCT/ DFT)", label: "Domestic Container Yard ( DCT/ DFT)" },
    { value: "ICD", label: "ICD" },
    { value: "Admin & Custom Building", label: "Admin & Custom Building" },
    { value: "Parking Area and Driver Rest Room", label: "Parking Area and Driver Rest Room" },
    { value: "Petrol Pump and Fuel Station", label: "Petrol Pump and Fuel Station" },
    { value: "Hotel", label: "Hotel" },
]

export const componentOptions = [
    { value: "Commercial Infrastruture", label: "Commercial Infrastruture" },
    { value: "Common Infrastructure", label: "Common Infrastructure" },
]

// export const componentOptions = [
//     { value: "Site Development", label: "Site Development" },
//     { value: "Warehouse-01", label: "Warehouse -01" },
//     { value: "Driver Rest Room", label: "Driver Rest Room" },
//     { value: "Admin Building", label: "Admin Building" },
//     { value: "Boded Warehouse", label: "Bonded Warehouse" },
//     { value: "Truck Parking", label: "Truck Parking" },
//     { value: "ICD", label: "ICD" },
//     { value: "DCT", label: "DCT" },
//     { value: "PFT Shed", label: "PFT Shed" },
//     { value: "Hotel", label: "Hotel" },
// ]

export const gfcStatusOptions = [
    { value: "In Progress", label: "In Progress" },
    { value: "Approved", label: "Approved" },
];

export const documentTypeOptions = [
    { value: "IFC Drawing", label: "IFC Drawing" },
    { value: "Tender Drawing", label: "Tender Drawing" },
    { value: "Shop Drawing", label: "Shop Drawing" },
    { value: "As-Built", label: "As-Built" },
    { value: "Statutory OC Drawings", label: "Statutory OC Drawings" },
];